import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema, identitySchema } from '@/core/components';

import { defaultPaperValues, paperSchema } from '../../Paper/model/PaperSchema';

export const reviewSchema = paperSchema.extend({
  type: identitySchema.nullable(),

  authors: z.array(authorSchema).min(1),
});

export const defaultReviewValues: DefaultValues<ReviewSchema> = {
  authors: [],
  type: null,
  ...defaultPaperValues,
};

export type ReviewSchema = z.infer<typeof reviewSchema>;
